import { TfiAngleLeft } from "react-icons/tfi";
import icon1 from "../assets/img/dashboard/detail-item-icon-1.png";
import icon2 from "../assets/img/dashboard/detail-item-icon-2.png";
import icon3 from "../assets/img/dashboard/detail-item-icon-3.png";
import icon4 from "../assets/img/dashboard/detail-item-icon-4.png";
import icon5 from "../assets/img/dashboard/detail-item-icon-5.png";
import icon6 from "../assets/img/dashboard/detail-item-icon-6.png";
import { Link } from "react-router-dom";
import metrics from "../helpersjson/Metrics.json";
import imagePng from "../assets/img/Group 1000004857.png";
import colorsData from "../Colors.json";
import LineChart from "./dashbaord/Linechart";
import Api from "../api/api";
import { useEffect } from "react";
import { useState } from "react";

const iconMap = {
  icon1: icon1,
  icon2: icon2,
  icon3: icon3,
  icon4: icon4,
  icon5: icon5,
  icon6: icon6,
};
export default function StrategiesDC({ onClick, data, openstr }) {
  const colors = colorsData.colors;
  const [chartDatas, setchartData] = useState([]);
  async function getrunschart() {
    const payload = {
      run_id: data?.run_id,
      run_type: data?.run_type,
    };
    try {
      let res = await Api.runresults(payload);
      setchartData(res.data.chart_data);
    } catch (error) {
      alert("Error while fetching Strategies");
    }
  }

  useEffect(() => {
    getrunschart();
  }, []);

  return (
    <div className="strategies-detail bg-white p-3 p-md-4">
      <div className="strategies-detail-header d-flex align-items-center gap-2">
        <div
          className=" cursor-pointer icon d-flex align-items-center justify-content-center"
          onClick={onClick}
        >
          <TfiAngleLeft />
        </div>
        <div className="text">
          <h4 className="fw-semibold lh-base text-heading mb-0">
            {data.strategy_name}
          </h4>
          {data?.published_user && (
            <p className="fs-14 lh-base fw-medium mt-1">
              By:{" "}
              <a href="#" className="text-decoration-underline">
                {data.published_user}
              </a>
            </p>
          )}
        </div>
      </div>
      <div className="d-flex align-items-center button flex-wrap pb-1">
        {data?.tags?.map((item, index) => (
          <span
            className="fs-12 lh-base fw-medium tags-capsule"
            style={{ backgroundColor: colors[index % colors.length] }}
          >
            {item}
          </span>
        ))}
        {/* <span className='fs-12 lh-base fw-medium text-heading'>Marketplace</span> */}
      </div>
      <div className="description">
        <h3 className="fs-14 lh-base fw-medium mb-0">Strategy description</h3>
        <p className="mb-2 pb-1 des fs-14 fw-normal">
          <div
            className="text-truncated"
            style={{ wordWrap: "break-word" }}
            dangerouslySetInnerHTML={{ __html: data?.strategy_desc }}
          />
        </p>
        <span className="cursor-pointer mb-2" onClick={openstr}>
          {" "}
          View More
        </span>
      </div>
      {/* <img src={imagePng} className="w-100"></img> */}
      {chartDatas && chartDatas.length > 0 && (
        <LineChart chartdata={chartDatas} borderColor={"#5ed9bf"} />
      )}
      <div className="detail-item d-flex gap-3 gap-md-2 flex-wrap">
        {metrics?.metrics?.map((item, index) => (
          <div
            key={index}
            className="detail-item-single p-2 d-flex align-items-center  gap-2"
          >
            <div className="icon bg-white d-flex align-items-center justify-content-center">
              <img src={iconMap[item.icon]} alt="" />
            </div>
            <div className="text">
              <h4 className="fs-14 lh-base fw-semibold text-heading mb-1">
                {data.metrics[item.key] ? data.metrics[item.key] : 0}
              </h4>
              <p className="fs-12 lh-base "> {item?.title} </p>
            </div>
          </div>
        ))}
      </div>
      {!data?.published_user && (
      <Link
        to={`/create-strategies?strategy=${data?.strategy_id}`}
        className="text-center fs-14 font-medium btn bg-primary mt-3"
      >
        Edit
      </Link>)}
    </div>
  );
}
